export default __webpack_public_path__ + "static/media/product-document.07a20a6a.svg";